import { render, staticRenderFns } from "./BackgroundAudioWithDnD.vue?vue&type=template&id=9c70a06e&scoped=true&"
import script from "./BackgroundAudioWithDnD.vue?vue&type=script&lang=ts&"
export * from "./BackgroundAudioWithDnD.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundAudioWithDnD.vue?vue&type=style&index=0&id=9c70a06e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c70a06e",
  null
  
)

export default component.exports